import { useCallback } from 'react';
export function useMergeRefs(refs) {
    return useCallback(function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref != null) {
                ;
                ref.current = value;
            }
        });
    }, [refs]);
}
